import { QuestionText as Text } from "./boxes/QuestionText";
import { QuestionBinary as Binary } from "./boxes/QuestionBinary";
import { QuestionSingleChoice as SingleChoice } from "./boxes/QuestionSingleChoice";
import { QuestionMultipleChoice as MultipleChoice } from "./boxes/QuestionMultipleChoice";
import { QuestionScale as Scale } from "./boxes/QuestionScale";
import { QuestionFile as File } from "./boxes/QuestionFile";

export var Question = {
  Text,
  Binary,
  SingleChoice,
  MultipleChoice,
  Scale,
  File,
};
